export default __webpack_public_path__ + "static/media/eventBanner.aaa7e68d.jpg";